import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  notation: stringField({ required: true }),
  type: stringField({ required: true }),
  ratio: stringField({ required: true }),
  label: stringField({ required: true })
};
